module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="first" href="#first" data-page="first">&laquo;</a>\n<a class="previous" href="#previous" data-page="previous">&lt;</a>\n\n<span class="pagination">\n  ';
 _.each(pagesBefore, function(page) { 
__p+='\n  <a class="page" href="#'+
((__t=( page ))==null?'':_.escape(__t))+
'" data-page="'+
((__t=( page ))==null?'':_.escape(__t))+
'">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a>\n  ';
 }) 
__p+='\n\n  <a class="current">'+
((__t=( currentPage ))==null?'':_.escape(__t))+
'</a>\n\n  ';
 _.each(pagesAfter, function(page) { 
__p+='\n  <a class="page" href="#'+
((__t=( page ))==null?'':_.escape(__t))+
'" data-page="'+
((__t=( page ))==null?'':_.escape(__t))+
'">'+
((__t=( page ))==null?'':_.escape(__t))+
'</a>\n  ';
 }) 
__p+='\n</span>\n\n<a class="next" href="#next" data-page="next">&gt;</a>\n<a class="last" href="#last" data-page="last">&raquo;</a>\n\n<select class="page_range pagination">\n  <option value="5">5</option>\n  <option value="10">10</option>\n  <option value="20">20</option>\n  <option value="50">50</option>\n  <option value="100">100</option>\n  <option value="150">150</option>\n  <option value="250">250</option>\n  <option value="500">500</option>\n</select>\n\n<p class="pagination">Number of Records To Display</p>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/pages/list.html
// module id = 197
// module chunks = 0